export const ANALYTICS_APP_BASENAME = '/a';

export const isAnalyticsAppPath = (path: string) =>
  path === ANALYTICS_APP_BASENAME || path.startsWith(`${ANALYTICS_APP_BASENAME}/`);

const routes = {
  AnalyticsAppOverview: () => ANALYTICS_APP_BASENAME,
  AnalyticsAppDashboards: () => `${ANALYTICS_APP_BASENAME}/dashboards`,
  AnalyticsAppReports: () => `${ANALYTICS_APP_BASENAME}/reports`,
  AnalyticsAppExports: () => `${ANALYTICS_APP_BASENAME}/deliveries`,
};

export default routes;
